
    try {
      // import.meta.env is only available in module scripts. Treat the string 'false' as explicit false.
      window.__ENABLE_THEME_FLICKER_FIX = import.meta.env.VITE_ENABLE_THEME_FLICKER_FIX !== 'false';
    } catch {}
  